import React,{useState} from 'react'
import {useDispatch} from 'react-redux'
import { useParams, Link, useHistory } from "react-router-dom"
import {
	editProgramAssignments,
	editProgramSettings,
	addProgramAssignments,
	setCopyModal,
} from '../programsSlice'
import DiscussResourceButton from '../../DiscussResourceButton/DiscussResourceButton'
import {getTrainerParam} from '../../../util/util'
import useCurrentUser from '../../../hooks/useCurrentUser'
import Button from 'react-bootstrap/Button'
import Form from 'react-bootstrap/Form'
import OverlayTrigger from "react-bootstrap/OverlayTrigger"
import Tooltip from "react-bootstrap/Tooltip"
import styles from './Program.module.css'

const Program = props => {
	const user = useCurrentUser()
	const dispatch = useDispatch()
	const history = useHistory()
	const {program} = props
	const trainer = getTrainerParam()
	const trainerParam = trainer ? `trainer=${trainer}` : ''
	const allowedToCopy = user.account_type !== 'client' 
	const isChain = user.account_type === 'chain'
	const handleEdit = ()=>{
		history.push(`/program-editor/?id=${program.program_id}`)
	}
	console.log(program)
	return (
		<div className={[
			"mt-3 border rounded p-3",
			styles.Program
		].join(' ')}>
			<div style={{flex:'0 0 auto',width:'180px'}} className="mr-3">
				<h6 className="m-0">
					<button 
						style={{background:'none',border:'none'}} 
						className="text-primary text-left" 
						onClick={handleEdit}
					>
						{props.program.programName}
					</button>
				</h6>
				<small>
					Length: {props.program.programLength} days
				</small>
				<hr className="my-1"/>
				{!isChain&&
					<div>
						<small>Assignments:</small>
						<div>
							<button 
								className="p-0 mr-2 text-primary"
								style={{
									fontSize:'12px',
									border:'none',
									background:'none',
								}}
								onClick={()=>{
									dispatch(editProgramAssignments(program.programID))
								}}>
								Existing
							</button>
							<button 
								className="p-0 text-primary"
								style={{
									fontSize:'12px',
									border:'none',
									background:'none',
								}}
								onClick={()=>{
									dispatch(addProgramAssignments(program.programID))
								}}>
								Add
							</button>
						</div>
					</div>
				}
			</div>
			{Boolean(props.program.programNotes)&&
				<div className="d-flex align-items-stretch flex-column">
					<div className="pr-2" style={{fontSize:'13px'}}>
						{props.program.programNotes}
					</div>
					{program.packages?.length > 0&&
						<div className="text-muted mt-auto">
							<hr className="my-1 w-100" />
							<div className="pr-2" style={{fontSize:'13px'}}>
								Linked Packages: {
									program.packages.slice(0,2).map(p=>p.package_name).join(', ')
								}
								{program.packages.length > 2&& 
									`and ${program.packages.length-2} other(s)`
								}
							</div>
						</div>
					}
				</div>
			}
			<div className={styles.Options}>
				{(Number(program.user_id_number) === Number(user.user_id_number)&&!isChain)&&
					<OverlayTrigger overlay={
						<Tooltip>
							Program Settings
						</Tooltip>
					}>
						<Button 
							className="m-1"
							onClick={()=>dispatch(editProgramSettings(program.programID))}
							size="sm" 
							variant="outline-secondary">
							<i className="fas fa-cog"></i>
						</Button>
					</OverlayTrigger>
				}
				{allowedToCopy&&
					<OverlayTrigger overlay={
						<Tooltip>
							Copy Program
						</Tooltip>
					}>
						<Button 
							className="m-1"
							onClick={()=>dispatch(setCopyModal({
								program_id:program.programID,
								show:true
							}))}
							size="sm" 
							variant="outline-primary">
							<i className="fas fa-copy"></i>
						</Button>
					</OverlayTrigger>
				}
				<OverlayTrigger overlay={
					<Tooltip>Discuss this program in the chat</Tooltip>
				}>
					<span>
						<DiscussResourceButton
							className="btn btn-sm btn-outline-info m-1"
							name={program.programName}
							id={program.programID}
							type="program"
						>
							<i className="fa fa-comments"/>
						</DiscussResourceButton>
					</span>
				</OverlayTrigger>
				{Number(program.user_id_number) === Number(user.user_id_number)&&
					<OverlayTrigger overlay={
						<Tooltip>
							Delete Program
						</Tooltip>
					}>
						<Button 
							className="m-1"
							onClick={()=>{
								props.onDelete(program.programID)
							}}
							size="sm" 
							variant="outline-danger">
							<i className="fas fa-trash"></i>
						</Button>
					</OverlayTrigger>
				}
			</div>
		</div>
	)
}

export default Program